import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { Binary } from 'types/Common';
import { getBinaryValue, getFormData } from 'utils/general';
import {
  ImageStyle,
  ImageScene,
  ImageBrandColor,
  GeneratedImage,
  AspectRatio,
} from './ai-image-generation.types';

interface GenerateImage {
  instructions: string;
  example?: File;
  style: ImageStyle;
  scene: ImageScene;
  brandColor: ImageBrandColor;
  people: Binary;
  aspectRatio: AspectRatio;
}

export const loaders = {
  generateImage: ({
    instructions,
    example,
    style,
    scene,
    brandColor,
    people,
    aspectRatio,
  }: GenerateImage) => {
    return api<{
      prompt: string;
      predictions: GeneratedImage[];
    }>({
      url: Endpoints.clientAdmin.images.generate,
      data: getFormData([
        { field: 'prompt', value: instructions },
        { field: 'style', value: style },
        { field: 'scene', value: scene },
        { field: 'brandColorsUsage', value: brandColor },
        {
          field: 'minimizeHumanPresence',
          value: String(!getBinaryValue(people)),
        },
        { field: 'numberOfImages', value: String(4) },
        { field: 'aspectRatio', value: aspectRatio.join(':') },
        ...(example ? [{ field: 'file', value: example }] : []),
      ]),
      method: 'post',
    });
  },
};
